import React from "react";
import TotalContent from "../components/pages/Dashboard/TotalContent";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const TotalContentLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <TotalContent />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default TotalContentLayout;